import styled from "styled-components";

export const CtaContainer = styled.div(() => ({
    flex: 1,
}));

export const PlanInfoCTATextWithIcon = styled.span`
    white-space: nowrap;
`;

export const ChevronIcon = styled.span(({ theme }) => ({
    display: "inline-block",
    marginLeft: theme.spacing.xxxSmall,
    /* override added as UI breaks if client repo has diff default line-height */
    lineHeight: 1,
    verticalAlign: "middle",
}));
